import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { SUCCESS, INFO, WARNING, ERROR, BANNER } from '../../redux/types';
import * as actions from '../../redux/actions';
import { img } from '../../config';

function Ui(props) {

  const showSpinner = () => {
    props.showSpinner('Showing super spinner');
    setTimeout(() => {
      props.hideSpinner();
    }, 3000);
  }

  const bannerUrl = img('banner-project-letnia-promocja.jpg');
  const mobileBannerUrl = img('banner-project-letnia-promocja-mobile.jpg');

  return (
    <div className="container default-fx">
      <div>
        <h2>Notyfikacje</h2>
        <Button variant="contained" onClick={() => props.notify('To jest informacja', 'info')} color="primary">Informacja</Button>
        <Button variant="contained" onClick={() => props.notify('To jest ostrzeżenie', 'warning')} color="primary">Ostrzeżenie</Button>
        <Button variant="contained" onClick={() => props.notify('Uwaga błąd!!!', 'error')} color="primary">Błąd</Button>
        <Button variant="contained" onClick={() => props.notify('Brawo :)', 'success')} color="primary">Sukces</Button>
        <Button variant="contained" onClick={() => props.hideNotification()} color="primary">Ukryj notyfikacje</Button>
      </div>
      <div>
        <h2>Komunikaty</h2>
        <p style={{ margin: 0 }}>Komunikaty będą dostępne dopiero po wdrożeniu nowego backendu</p>
        <Button variant="contained" onClick={() => props.addMessage('To jest ważna informacja', INFO)} color="primary">Informacja</Button>
        <Button variant="contained" onClick={() => props.addMessage('Uwaga, to jest ostrzeżenie', WARNING)} color="primary">Ostrzeżenie</Button>
        <Button variant="contained" onClick={() => props.addMessage('Błąd - twoja subskrypcja wygaśnie za 3 dni. Skontaktuj się z biurem obsługi klienta w celu kontynuowania usługi.', ERROR)} color="primary">Błąd</Button>
        <Button variant="contained" onClick={() => props.addMessage('Brawo :)', SUCCESS)} color="primary">Sukces</Button>
        <Button variant="contained" onClick={() => props.addMessage('', BANNER, bannerUrl, mobileBannerUrl, 'https://www.szybkiangielski.pl')} color="primary">Banner</Button>
      </div>
      <div>
        <h2>Spinner</h2>
        <Button variant="contained" onClick={showSpinner} color="primary">Pokaż spinner</Button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { auth, notes, config, messages, userState, tools } = state;
  return { auth, notes, config, messages, userState, tools }
}

export default connect(mapStateToProps, actions)(Ui);
